<template>
    <section class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Dano ou avaria' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />
        </div>
        <div v-if="!resumo">
            <TipoVeiculo @aoSelecionarTipo="selecionarTipoVeiculo" />
            <h4 class="pb-2">Adicione danos ou avarias do veículo:</h4>
            
            <router-link v-if="!preview" :to="`/${identificadorRota}/${localRealizacao}/${modulo}/etapa/${etapaComponente}/${idComponente}/detalhe-avaria`">
                <CroquiAvaria :croquisAvarias="croquisAvarias" :tipoCaminhao="tipoCaminhao" :exibirIndicador="exibirIndicador" :semAvaria="semAvaria" />
            </router-link>
            <CroquiAvaria v-else :croquisAvarias="croquisAvarias" :tipoCaminhao="tipoCaminhao" :exibirIndicador="exibirIndicador" :semAvaria="semAvaria" />

            <div class="flex items-center gap-2 text-azul-info justify-center pt-4">
                <span class="material-symbols-outlined">touch_app</span>
                <span>Clique na imagem e marque os pontos das avarias.</span>
            </div>
        </div>
        <div v-else>
            <AvariaResumo :croquisAvarias="croquisAvarias" :tipoCaminhao="tipoCaminhao" />
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import TipoVeiculo from '@/components/TipoVeiculo.vue';
import AvariaResumo from '@/common/avaria/components/AvariaResumo.vue';
import Status from '@/components/Status.vue';
import ComponenteAvariaService from '@/services/componentes/ComponenteAvariaService';
import CroquiAvaria from '@/common/avaria/components/CroquiAvaria.vue';
import CroquisAvariasConstant from '@/constants/CroquisAvariasConstant';

export default defineComponent({
    name: 'Avaria',
    components: {
        TipoVeiculo,
        AvariaResumo,
        Status,
        CroquiAvaria
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        selecionarTipoVeiculo(tipoVeiculo) {
            this.tipoVeiculo = tipoVeiculo.chave
            this.croquisAvarias = CroquisAvariasConstant.CROQUI_VEICULO(tipoVeiculo.chave);
            this.exibirIndicador = true
        }
    },
    setup(props) {
        return ComponenteAvariaService.setup(props)
    }
});
</script>
